import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Check, ShieldCheck } from "lucide-react";

const ORDER_URL = "https://multipolar.acinvesting.fr/commande";

const included = [
  "Les 5 actes de MULTIPOLAR",
  "Les sources (PDF)",
  "Un accès à vie au contenu et à ses mises à jour",
  "Ton premier mois d'OPENACCESS offert",
];

export default function Pricing() {
  return (
    <section id="tarif" data-testid="pricing-section" className="py-24 md:py-32 border-b border-white/10 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(217,45,32,0.08),transparent_60%)]" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="text-center mb-14"
        >
          <span className="micro-label">L'offre</span>
          <h2 className="font-display text-4xl sm:text-5xl leading-[1.05] mt-6" data-testid="pricing-title">
            Une décennie de lecture<br />pour <span className="italic text-[#FF6B00]">un seul paiement</span>.
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="max-w-2xl mx-auto border border-white/15 bg-white/[0.02] rounded-sm"
          data-testid="pricing-card"
        >
          <div className="flex items-center justify-between px-8 py-4 border-b border-white/10">
            <span className="font-mono text-[10px] tracking-[0.3em] text-[#758D85]">RÉF. MP-2026</span>
            <span className="font-mono text-[10px] tracking-[0.3em] text-[#FF6B00]">ACCÈS À VIE</span>
          </div>
          <div className="p-8 md:p-10">
            <div className="flex items-end gap-3">
              <span className="font-display text-6xl text-[#F5F5F0]" data-testid="pricing-amount">119&nbsp;€</span>
              <span className="font-mono text-xs text-[#758D85] pb-2 tracking-widest uppercase">Paiement unique</span>
            </div>
            <p className="mt-4 text-[15px] text-[#D8D4CC]">
              MULTIPOLAR. Accès immédiat après paiement.
            </p>

            <ul className="mt-8 space-y-3">
              {included.map((item) => (
                <li key={item} className="flex items-start gap-3 text-[15px] text-[#D8D4CC]">
                  <Check size={16} className="text-[#FF6B00] mt-0.5 shrink-0" strokeWidth={2.5} />
                  {item}
                </li>
              ))}
            </ul>

            <a
              href={ORDER_URL}
              data-testid="checkout-button"
              className="mt-10 w-full bg-[#D92D20] hover:bg-[#b3241a] text-white font-mono text-sm tracking-[0.2em] uppercase py-5 rounded-sm transition-[background-color,transform] duration-300 hover:scale-[1.01] flex items-center justify-center gap-3"
            >
              Accéder
            </a>
            <div className="mt-6 flex items-center justify-center gap-2 text-xs text-[#758D85]">
              <ShieldCheck size={14} className="text-[#027A48]" />
              Paiement sécurisé
            </div>
          </div>
        </motion.div>

        <p className="mt-10 !text-sm text-[#758D85] text-center" data-testid="pricing-acprivate-link">
          Tu préfères suivre mes décisions au quotidien ?{" "}
          <Link to="/openaccess" className="text-[#A3B8B0] hover:text-[#FF6B00] underline underline-offset-4 transition-colors">
            Découvre OPENACCESS
          </Link>
          .
        </p>
      </div>
    </section>
  );
}
